import styled from '@emotion/styled';
import { dropdownWrapper } from 'src/assets/colors';

export const OptionWrapper = styled('div', { label: 'OptionWrapper' })<{ isSelected?: boolean; isFocused?: boolean }>`
    background-color: ${({ isSelected, isFocused }): string =>
        isFocused === true
            ? dropdownWrapper.option.bgColorFocused
            : isSelected === true
              ? dropdownWrapper.option.bgColorSelected
              : dropdownWrapper.option.bgColor};
    color: ${({ isSelected, isFocused }): string =>
        isSelected === true || isFocused === true ? dropdownWrapper.option.txtColorSelected : dropdownWrapper.option.txtColor};
    cursor: pointer;
    display: block;
    min-height: 26px;
    padding: 8px 10px;
    border-bottom: 1px solid ${dropdownWrapper.option.borderColor};
    font-weight: 400;
    white-space: nowrap;
    vertical-align: middle;

    &:last-child {
        border-bottom: none;
    }

    span {
        align-items: center;
        display: flex;
    }

    .famfamfam-flags {
        margin-right: 5px;
        vertical-align: middle;
    }
`;

export const CountryDropdownWrapper = styled('div', { label: 'CountryDropdownWrapper' })`
    .famfamfam-flags {
        margin-right: 5px;
        vertical-align: middle;
        background-repeat: no-repeat;
        background-size: 224px 199px;
        display: inline-block;
        height: 11px;
        width: 16px;
    }
`;
